export default __webpack_public_path__ + "static/media/shlomo-kaaaei.5ed282d0.png";